import React from 'react';
import { FormattedMessage } from 'react-intl';

import { formatLabel } from './utils';

const CustomTooltip = ({
  active,
  payload,
  stackByEntities,
  stackByType,
  isStacked,
  xLabelEntities,
  xLabelType,
  isPie = false,
  isBurnChart = false,
}) => {
  if (!active || !payload || !payload.length) {
    return null;
  }

  const formatStackLabel = (key) => {
    return formatLabel(key, stackByType, stackByEntities);
  };

  const getDisplayName = () => {
    const rawName = payload[0]?.payload?.name || payload[0]?.name;
    return formatLabel(rawName, xLabelType, xLabelEntities);
  };

  if (isPie) {
    const data = payload[0];
    const percentage = ((data.value / data.payload.total) * 100).toFixed(1);

    return (
      <div className="bg-white px-4 py-3 rounded-lg shadow-xl border border-gray-200">
        <p className="font-semibold text-gray-900 mb-1">{getDisplayName()}</p>
        <div className="flex items-center gap-2">
          <div
            className="w-3 h-3 rounded-sm"
            style={{ backgroundColor: data.payload.fill }}
          />
          <p className="text-sm text-gray-600">
            <FormattedMessage id="COUNT" defaultMessage="Count" />:{' '}
            <span className="font-semibold text-indigo-600">{data.value}</span>
            <span className="text-gray-500"> ({percentage}%)</span>
          </p>
        </div>
      </div>
    );
  }

  if (isBurnChart) {
    const dataPoint = payload[0]?.payload;

    return (
      <div className="bg-white px-4 py-3 rounded-lg shadow-xl border border-gray-200">
        <p className="font-semibold text-gray-900 mb-2">{getDisplayName()}</p>
        {payload.map((entry, index) => (
          <div
            key={`item-${index}`}
            className="flex justify-between items-center gap-3 mb-1"
          >
            <div className="flex items-center gap-2">
              <div
                className="w-3 h-3 rounded-sm"
                style={{ backgroundColor: entry.color }}
              />
              <span className="text-sm text-gray-600">{entry.name}:</span>
            </div>
            <span className="text-sm font-semibold text-gray-900">
              {entry.value}
            </span>
          </div>
        ))}
        {dataPoint?.total !== undefined && (
          <div className="border-t border-gray-200 mt-2 pt-2">
            <div className="flex justify-between items-center">
              <span className="text-sm font-semibold text-gray-700">
                <FormattedMessage id="TOTAL" defaultMessage="Total" />:
              </span>
              <span className="text-sm font-semibold text-indigo-600">
                {dataPoint.total}
              </span>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="bg-white px-4 py-3 rounded-lg shadow-xl border border-gray-200">
      {isStacked ? (
        <>
          <p className="font-semibold text-gray-900 mb-2">{getDisplayName()}</p>
          {payload.map((entry, index) => (
            <div
              key={`item-${index}`}
              className="flex justify-between items-center gap-3 mb-1"
            >
              <div className="flex items-center gap-2">
                <div
                  className="w-3 h-3 rounded-sm"
                  style={{ backgroundColor: entry.color }}
                />
                <span className="text-sm text-gray-600">
                  {formatStackLabel(entry.dataKey)}:
                </span>
              </div>
              <span className="text-sm font-semibold text-gray-900">
                {entry.value}
              </span>
            </div>
          ))}
          <div className="border-t border-gray-200 mt-2 pt-2">
            <div className="flex justify-between items-center">
              <span className="text-sm font-semibold text-gray-700">
                <FormattedMessage id="TOTAL" defaultMessage="Total" />:
              </span>
              <span className="text-sm font-semibold text-indigo-600">
                {payload.reduce((sum, entry) => sum + (entry.value || 0), 0)}
              </span>
            </div>
          </div>
        </>
      ) : (
        <>
          <p className="font-semibold text-gray-900">{getDisplayName()}</p>
          <p className="text-sm text-gray-600 mt-1">
            <FormattedMessage id="COUNT" defaultMessage="Count" />:{' '}
            <span className="font-semibold text-indigo-600">
              {payload[0].value}
            </span>
          </p>
        </>
      )}
    </div>
  );
};

export default CustomTooltip;
